var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.dataFrom.templateId ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "type",
      label: _vm.$t("类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("类型"),
      allowClear: ""
    },
    model: {
      value: _vm.dataFrom.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "type", $$v);
      },
      expression: "dataFrom.type"
    }
  }, _vm._l(_vm.typeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("名称")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "code",
      label: _vm.$t("代码")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.code,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "code", $$v);
      },
      expression: "dataFrom.code"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "sort",
      label: _vm.$t("排序")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.dataFrom.sort,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "sort", $$v);
      },
      expression: "dataFrom.sort"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "display",
      label: _vm.$t("控件")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("控件"),
      allowClear: ""
    },
    model: {
      value: _vm.dataFrom.display,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "display", $$v);
      },
      expression: "dataFrom.display"
    }
  }, _vm._l(_vm.controlList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "isTag",
      label: _vm.$t("是否生成标签")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.isTag,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "isTag", $$v);
      },
      expression: "dataFrom.isTag"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("否")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("是")) + " ")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };